//  For each product on the page
(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }


    const product = JSON.parse(section.querySelector(".productV23JSON").textContent);
    let hotCocoProduct = JSON.parse(section.querySelector(".productHotCocoV4JSON").textContent);
    const variantIDtoColor = JSON.parse(section.querySelector(".productV23VariantIDtoColor").textContent);
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);
    const subscriptionAppID = section.querySelector(".productV23SubscriptionAppID").textContent;
    const cartNote = JSON.parse(section.querySelector(".productV23CartNote").textContent);

    let quantity = 1;

    const hasSticky = !!section.querySelector(".productV23Sticky");

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    // function to return the selling_plan_id given a variant ID
    function getSellingPlanID(product, activeVariant) {
        // create an array of selling plans that are accessible for the variant
        const validSellingPlans = [];

        // loop over each group
        for (const group of product.selling_plan_groups) {
            // if the group doesn't match our subscription app ID, skip it
            if (group.app_id !== subscriptionAppID) {
                continue
            }

            // loop through each selling plan in the group
            for (const plan of group.selling_plans) {
                // add the plan ID to the validSellingPlans array
                validSellingPlans.push(plan.id);
            }
        }

        // loop through selling plan allocations of the variant and find the first one that matches a valid selling plan
        for (const allocation of activeVariant.selling_plan_allocations) {
            if (validSellingPlans.includes(allocation.selling_plan_id)) {
                return allocation.selling_plan_id;
            }
        }

        // if no valid selling plan is found, return null
        return null;
    }


    /************
     Product Swipers
     ************/

        // hydrate each wrap's swipers only the first time it becomes visible
    const initializedWraps = new WeakSet();

    function ensureSwipers(element) {
        if (!element || initializedWraps.has(element)) {
            return;
        }
        initializedWraps.add(element);

        const thumbsSwiper = new Swiper(element.querySelector(".productV23VisualThumbs"), {
            slidesPerView: 6,
            spaceBetween: 10,
            loop: true,
            breakpoints: {
                800: {
                    slidesPerView: 6,
                    spaceBetween: 23
                }
            }
        });

        new Swiper(element.querySelector(".productV23VisualSwiper"), {
            slidesPerView: 1,
            spaceBetween: 6,
            loop: true,
            navigation: {
                nextEl: element.querySelector(".productV23VisualSwiperNext"),
                prevEl: element.querySelector(".productV23VisualSwiperPrev"),
            },
            breakpoints: {
                800: {
                    spaceBetween: 23
                }
            },
            thumbs: {
                swiper: thumbsSwiper
            },
            autoHeight: true,
        });
    }

    // only init swipers for the wrap(s) already marked active by liquid
    section.querySelectorAll(".productV23VisualWrap.active").forEach(ensureSwipers);

    // Quotes swiper
    if (section.querySelector(".productV23Quotes")) {
        new Swiper(section.querySelector(".productV23Quotes"), {
            slidesPerView: 1,
            spaceBetween: 16,
            loop: true,
            speed: 4000,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            }
        });
    }

    // change slide on thumbnail click
    section.querySelectorAll(".productV23VisualThumbsSlide").forEach(element => {
        element.addEventListener("click", function () {
            // change slide
            productSwiper.slideTo(this.dataset.index - 1);
        });
    });

    let cocoSelected = false;

    function checkCocoSelected() {
        // if there's no sweetener selector, we don't care
        if (!section.querySelector('.productV23FormOptionsItemValuesLabelInput.sweetener')) {
            return false;
        }


        return section.querySelector('.productV23FormOptionsItemValuesLabelInput.flavor:checked')?.value === 'Hot Cocoa' || false;
    }

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {

            // show/hide sweetener selectors - only show for hot Coco
            if (checkCocoSelected()) {
                section.querySelector('.productV23FormOptionsWrap').classList.add('active');
            } else {
                section.querySelector('.productV23FormOptionsWrap')?.classList.remove('active');
            }

            updateProduct();
        });
    })

    // show/hide sweetener selectors - only show for hot Coco on load
    if (checkCocoSelected()) {
        section.querySelector('.productV23FormOptionsWrap').classList.add('active');
    } else {
        section.querySelector('.productV23FormOptionsWrap')?.classList.remove('active');
    }

    /**************
     Update Product
     ***************/

    function isSubscription() {
        return !!document.querySelector(`.productV23SubLabelInput[value="sub"]:checked`);
    }

    async function updateProduct() {
        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productV23FormOptionsItem`).forEach(group => {

                // disregard sweetener options
                if (!group.classList.contains('sweetener')) {
                    options.push(group.querySelector(`input:checked`).value);
                }
            });


            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".productV23ATC").disabled = true;
            section.querySelector(".productV23ATCText").textContent = "Not Available";
            return;
        }

        // delivery frequency
        section.querySelectorAll(".productV23SubLabelBodyBulletsItemTxt .frequency")?.forEach((item) => {
            item.textContent = "";
        })

        // flavor choice
        section.querySelectorAll('.productV23FormOptionsItemLabelChoice')?.forEach((item) => {
            item.textContent = activeVariant.options[0];
            item.style.color = variantIDtoColor[activeVariant.id];
        })


        /**************
         Price
         ***************/

        let sellingPlanExists = document.querySelector('.productV23SubLabel') || false;

        let sellingPlanID = null;
        let sellingPlan = null;


        // if there's a subscription we need to update both prices
        if (sellingPlanExists) {
            // Select both sets of elements at once
            const compares = section.querySelectorAll(".productV23SubLabelBodyHeaderPriceCompare");
            const reals = section.querySelectorAll(".productV23SubLabelBodyHeaderPriceReal");

            // reset compare
            compares.forEach(item => {
                item.textContent = "";
            });

            // Destructure them for clarity:
            // Assuming the markup is structured so that index 0 is for subscription, index 1 for one-time purchase
            const [subCompare, oneTimeCompare] = compares;
            const [subReal, oneTimeReal] = reals;


            // find the allocation that matches the selling plan ID
            sellingPlanID = getSellingPlanID(product, activeVariant);
            if (sellingPlanID) {
                // find the allocation so we can determine price for this variant
                let allocation = activeVariant.selling_plan_allocations.find(allocation => allocation.selling_plan_id === sellingPlanID);

                // find the selling plan by ID to determine the frequency
                sellingPlan = product.selling_plan_groups.flatMap(group => group.selling_plans).find(plan => plan.id === sellingPlanID);

                const allocationPrice = allocation.price;

                // Update subscription prices
                if (activeVariant.price > allocationPrice) {
                    subCompare.textContent = price(activeVariant.price, true);
                }
                subReal.textContent = price(allocationPrice, true);

                // Update one-time purchase prices
                if (activeVariant.compare_at_price > activeVariant.price) {
                    oneTimeCompare.textContent = price(activeVariant.compare_at_price, true);
                }
                oneTimeReal.textContent = price(activeVariant.price, true);


                // delivery frequency
                section.querySelectorAll(".productV23SubLabelBodyBulletsItemTxt .frequency")?.forEach((item) => {
                    item.textContent = sellingPlan.name;
                })
            }
        }

        // update swiper
        let hasDefaultSwiper = document.querySelector('.productV23VisualWrap.default') || false;
        if (hasDefaultSwiper) {

        } else {

            let variant = activeVariant;
            // check if hot cocoa and sweetener is selected
            let sweetenerSelected = section.querySelector('.productV23FormOptionsItemValuesLabelInput.sweetener:checked')?.value === "Homestyle" || false;

            // if hot cocoa and sweetener is selected, use the hot cocoa product (separate product)
            if (checkCocoSelected() && sweetenerSelected) {
                let options = [];
                section.querySelectorAll(`.productV23FormOptionsItem`).forEach(group => {
                    options.push(group.querySelector(`input:checked`).value);

                    // find new variant based on the options
                    variant = hotCocoProduct.variants.find((variant) => {
                        return JSON.stringify(variant.options) === JSON.stringify(options)
                    });

                });
            }

            section.querySelector('.productV23VisualWrap.active')?.classList.remove('active');
            const gallerySelector = isSubscription() ? 'sub' : 'once';
            const newActiveWrap = section.querySelector(`.productV23VisualWrap.${gallerySelector}[data-id='${variant.id}']`);
            if (newActiveWrap) {
                newActiveWrap.classList.add('active');
                ensureSwipers(newActiveWrap);
            }
        }

        // shipping text
        document.querySelectorAll('.productV23IconsItem')?.forEach(item => {
            // if there is a .productIconsItemTxt.sub, check if we're subscribed
            if (item.querySelector('.productV23IconsItemTxt.sub')) {
                if (isSubscription()) {
                    item.querySelector('.productV23IconsItemTxt.sub').classList.add('active');
                    item.querySelector('.productV23IconsItemTxt.once').classList.remove('active');
                } else {
                    item.querySelector('.productV23IconsItemTxt.sub').classList.remove('active');
                    item.querySelector('.productV23IconsItemTxt.once').classList.add('active');

                }
            }
        })


        // update price
        section.querySelector(".productV23ATCPrice").textContent = price(activeVariant.price, true);
        if (isSubscription()) {
            let sellingPlanID = getSellingPlanID(product, activeVariant);
            if (sellingPlanID) {
                let allocation = activeVariant.selling_plan_allocations.find(allocation => allocation.selling_plan_id === sellingPlanID);
                section.querySelector(".productV23ATCPrice").textContent = price(allocation.price, true);
            }
        }

        /**************
         ATC Enable/Disable
         ***************/

        // selling plan check
        if (sellingPlanExists && !sellingPlan && isSubscription()) {
            section.querySelector(".productV23ATC").disabled = true;
            section.querySelector(".productV23ATCText").textContent = "Subscription Unavailable";
        }

        // check if the variant is in stock
        else if (activeVariant.available) {
            section.querySelector(".productV23ATC").disabled = false;
            section.querySelector(".productV23ATCText").textContent = "Add To Cart";
        } else {
            section.querySelector(".productV23ATC").disabled = true;
            section.querySelector(".productV23ATCText").textContent = "Sold Out";
        }


        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // if the path isn't a product page, the variant param won't automatically update the active variant, so we need to do it manually on load
    let urlVariant = new URLSearchParams(window.location.search).get("variant");
    if (!window.location.pathname.includes("/products/") && urlVariant) {

        // if no variant found, return early
        if (!product.variants.find(variant => variant.id === parseInt(urlVariant))) {
            return;
        }

        // find the options that make up the variant and select them
        let variant = product.variants.find(variant => variant.id === parseInt(urlVariant));
        let options = variant.options;
        // auto select flavor
        section.querySelectorAll('.productV23FormOptionsItemValuesLabelInput.flavor').forEach((input) => {
            if (input.value === options[0]) {
                input.checked = true;
            }
        })
        // auto select size
        section.querySelectorAll('.productV23FormOptionsItemValuesLabelInput.size').forEach((input) => {
            if (input.value === options[1]) {
                input.checked = true;
            }
        })

    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();

    /**************
     Delivery time
     ***************/
    let deliveryExists = section.querySelector(".productV23Shipping") || false;
    if (deliveryExists) {
        // get cutoff time (0-24 hour)
        let cutoff = parseInt(section.querySelector(".productV23Shipping").dataset.cutoff);
        // get current time
        let now = new Date();
        let hours = now.getHours();
        let minutes = now.getMinutes();
        let seconds = now.getSeconds();

        // get time until next cutoff
        let timeUntilCutoff = (cutoff - hours) * 60 * 60 - (minutes * 60 + seconds);
        if (timeUntilCutoff < 0) {
            timeUntilCutoff += 24 * 60 * 60;
        }
        // convert to hours, minutes, seconds
        let hoursUntilCutoff = Math.floor(timeUntilCutoff / 3600);
        let minutesUntilCutoff = Math.floor((timeUntilCutoff % 3600) / 60);

        // update text (x hrs x mins)
        if (section.querySelector('.productV23ShippingOrderCutoff')) {
            section.querySelector('.productV23ShippingOrderCutoff').textContent = `${hoursUntilCutoff} hrs ${minutesUntilCutoff} mins`;
        }

        // update text every second
        setInterval(() => {
            // get current time
            now = new Date();
            hours = now.getHours();
            minutes = now.getMinutes();
            seconds = now.getSeconds();

            // get time until next cutoff
            timeUntilCutoff = (cutoff - hours) * 60 * 60 - (minutes * 60 + seconds);
            if (timeUntilCutoff < 0) {
                timeUntilCutoff += 24 * 60 * 60;
            }
            // convert to hours, minutes, seconds
            hoursUntilCutoff = Math.floor(timeUntilCutoff / 3600);
            minutesUntilCutoff = Math.floor((timeUntilCutoff % 3600) / 60);

            // update text (x hrs x mins)
            if (section.querySelector('.productV23ShippingOrderCutoff')) {
                section.querySelector('.productV23ShippingOrderCutoff').textContent = `${hoursUntilCutoff} hrs ${minutesUntilCutoff} mins`;

            }

        }, 1000);
    }


    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productV23ATC").classList.add("loading");
        if (hasSticky) section.querySelector(".productV23StickyATC").classList.add("loading");

        // check if hot cocoa and sweetener is selected
        let sweetenerSelected = section.querySelector('.productV23FormOptionsItemValuesLabelInput.sweetener:checked')?.value === "Homestyle" || false;

        // if hot cocoa and sweetener is selected, use the hot cocoa product (separate product)
        if (checkCocoSelected() && sweetenerSelected) {
            let options = [];
            section.querySelectorAll(`.productV23FormOptionsItem`).forEach(group => {
                options.push(group.querySelector(`input:checked`).value);

                // find new variant based on the options
                activeVariant = hotCocoProduct.variants.find((variant) => {
                    return JSON.stringify(variant.options) === JSON.stringify(options)
                });

            });
        }

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // check for discount kit value
        if (section.querySelector(".productV23ATC").dataset.discountKit) {
            formData.items[0].properties = {
                _discount_kit: section.querySelector(".productV23ATC").dataset.discountKit
            }
        }

        // check for cart note
        if (cartNote) {
            formData.items[0].properties = {
                'Please Note': cartNote,
            }
        }

        // check for selling plan
        if (isSubscription()) {
            if (checkCocoSelected() && sweetenerSelected) {
                formData.items[0].selling_plan = getSellingPlanID(hotCocoProduct, activeVariant);
            } else {
                formData.items[0].selling_plan = getSellingPlanID(product, activeVariant);
            }
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productV23ATC").classList.remove("loading");
        if (hasSticky) section.querySelector(".productV23StickyATC").classList.remove("loading");

    }

    section.querySelector('.productV23ATC').addEventListener("click", addToCart);

    // LP pages scroll to product links
    document.querySelectorAll(`a[href="#product"]`)?.forEach(link => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
            // scroll to the form options, offset 100px above so it isn't flush to the top
            const target = section.querySelector(".productV23FormOptions").getBoundingClientRect().top + window.scrollY - 120;
            window.scrollTo({top: target, behavior: "smooth"});
        })
    })

})();
